module.exports = __webpack_public_path__ + "img/green-tab.f3c887f8.svg";